import MyAccountClient from  "../pages/User/Client/my-account"
import ClientCalendar from  "../pages/User/Client/Calendar"
import ClientTransaction from  "../pages/User/Client/Transaction"
import MyAccountWorker from  "../pages/User/Worker/my-account"
import WorkerCalendar from  "../pages/User/Worker/Calendar"
import OrganizationPage from  "../pages/User/Organization"
import MediaPage from  "../pages/User/Media"

const baseTitle = "Gmatik - "
const urlBase = "/dash"

export const RouteUser = {
    MY_ACCOUNT_CLIENT: {
        path: `${urlBase}/client/my-account`,
        menu: "tipoServicios",
        menuChild: "",
        page: MyAccountClient,
        title: `${baseTitle}Mi cuenta`,
        roles: ["ROLE_CLIENT"]
    },
    MY_ACCOUNT_WORKER: {
        path: `${urlBase}/worker/my-account`,
        menu: "tipoServicios",
        menuChild: "",
        page: MyAccountWorker,
        title: `${baseTitle}Mi cuenta`,
        roles: ["ROLE_WORKER"]
    },
     CLIENT_CALENDAR: {
         path: `${urlBase}/client/calendar`,
         menu: "tipoServicios",
         menuChild: "",
         page: ClientCalendar,
         title: `${baseTitle}Mi calendario`,
         roles: ["ROLE_CLIENT"]
     },
     CLIENT_TRANSACTION: {
         path: `${urlBase}/client/transaction`,
         menu: "tipoServicios",
         menuChild: "",
         page: ClientTransaction,
         title: `${baseTitle}Mis facturas`,
         roles: ["ROLE_CLIENT"]
     },
     WORKER_CALENDAR: {
         path: `${urlBase}/worker/calendar`,
         menu: "tipoServicios",
         menuChild: "",
         page: WorkerCalendar,
         title: `${baseTitle}Mi calendario`,
         roles: ["ROLE_WORKER"]
     },
     ORGANIZATION: {
        path: `${urlBase}/organization`,
        menu: "organization",
        menuChild: "",
        page: OrganizationPage,
        title: `${baseTitle}Organización`,
        roles: ["ROLE_CLIENT", "ROLE_WORKER"]
    },
    MEDIA: {
        path: `${urlBase}/media`,
        menu: "media",
        menuChild: "",
        page: MediaPage,
        title: `${baseTitle}Documentación`,
        roles: ["ROLE_CLIENT", "ROLE_WORKER"]
    }
    
}
